/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const productliblalycatalog = () => {
		// /products/library/catalog_ink/index.html
		// /products/library/catalog_chemical/index.html
		// /products/library/catalog_processing/index.html
		if(document.querySelectorAll('.js-products-catalog-ancher').length) {
			const getJSONfiles = (_id) => {
				return `/ajax/products/library/catalog/${_id}.json`;
			};
			// 出す項目だけ抽出
			let itemArray = [];
			let count = 0;
			new Promise((resolve) => {
				document.querySelectorAll('.js-products-catalog-ancher > li').forEach((ele, index) => {
					fetch(getJSONfiles(ele.querySelector('.rt_cf_pcl_id').textContent)).then(function (data) {
						return data.json();
					}).then(function (data) {
						// console.log(data,'data');
						count += 1;
						if(data.rt_bn_product_list[0].cf_p_classification.cf_pcl_chooseable_type) {
							itemArray.push({ html: data.rt_bn_product_list, idx: index });
						} else {
							let catalogitem = false;
							data.rt_bn_product_list.forEach((lisyelm) => {
								if(lisyelm.cf_p_individual_catalog_disp1) {
									catalogitem = true;
								}
							});
							if(catalogitem) {
								itemArray.push({ html: data.rt_bn_product_list, idx: index });
							}
						}
						if((count) == document.querySelectorAll('.js-products-catalog-ancher > li').length) {
							return resolve(itemArray);
						}
					});
				});
			}).then(() => {
				itemArray.sort((a, b) => a.idx - b.idx);
				// console.log(itemArray,'itemArray');
				const bytesToSize = (bytes) => {
					var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
					if (bytes === 0) {
						return 'n/a';
					}
					var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
					if (i === 0) {
						return bytes + ' ' + sizes[i];
					}
					return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
				}
				itemArray.forEach((ele,idx) => {
					// console.log(ele,idx);
					let num = idx + 1;
					let numtext = '#catalog_ink'+(("0" + num).slice(-2));
					// 出す項目に連番でidを指定してページ内リンクを表示
					document.querySelectorAll('.js-products-catalog-ancher > li').forEach(eleli => {
						if(eleli.querySelector('.rt_cf_pcl_classification_name_ja').textContent == ele.html[0].cf_p_classification.cf_pcl_classification_name_ja) {
							eleli.querySelector('a').setAttribute('href', numtext);
							eleli.classList.remove('di_none');
						}
					});
					let HTML = `<h4 id="${numtext.slice(1)}">${ele.html[0].cf_p_classification.cf_pcl_classification_name_ja}</h4>
					<div class="txt_desc_catalog">${ele.html[0].cf_p_classification.cf_pcl_chooseable_type}</div>`;
					let _catalogarray = [];
					ele.html.forEach(catalogele => {
						if(catalogele.cf_p_individual_catalog_disp1) {
							let _src = '';
							if(catalogele.rt_cf_p_individual_catalog1_thumb) {
								if(catalogele.rt_cf_p_individual_catalog1_thumb.src) {
									_src = catalogele.rt_cf_p_individual_catalog1_thumb.src;
								}
							}
							let _href = '';
							if(catalogele.rt_cf_p_individual_catalog1_href) {
								if(catalogele.rt_cf_p_individual_catalog1_href.href) {
									_href = catalogele.rt_cf_p_individual_catalog1_href.href;
								}
							}
							let _size = '';
							if(catalogele.rt_cf_p_individual_catalog1_size) {
								if(catalogele.rt_cf_p_individual_catalog1_size.content) {
									_size = bytesToSize(catalogele.rt_cf_p_individual_catalog1_size.content);
								}
							}
							_catalogarray.push({
								title: catalogele.cf_p_individual_catalog_disp1,
								src: _src,
								href: _href,
								size: _size,
							});
						}
						if(catalogele.cf_p_individual_catalog_disp2) {
							let _src = '';
							if(catalogele.rt_cf_p_individual_catalog2_thumb) {
								if(catalogele.rt_cf_p_individual_catalog2_thumb.src) {
									_src = catalogele.rt_cf_p_individual_catalog2_thumb.src;
								}
							}
							let _href = '';
							if(catalogele.rt_cf_p_individual_catalog2_href) {
								if(catalogele.rt_cf_p_individual_catalog2_href.href) {
									_href = catalogele.rt_cf_p_individual_catalog2_href.href;
								}
							}
							let _size = '';
							if(catalogele.rt_cf_p_individual_catalog2_size) {
								if(catalogele.rt_cf_p_individual_catalog2_size.content) {
									_size = bytesToSize(catalogele.rt_cf_p_individual_catalog2_size.content);
								}
							}
							_catalogarray.push({
								title: catalogele.cf_p_individual_catalog_disp2,
								src: _src,
								href: _href,
								size: _size,
							});
						}
						if(catalogele.cf_p_individual_catalog_disp3) {
							let _src = '';
							if(catalogele.rt_cf_p_individual_catalog3_thumb) {
								if(catalogele.rt_cf_p_individual_catalog3_thumb.src) {
									_src = catalogele.rt_cf_p_individual_catalog3_thumb.src;
								}
							}
							let _href = '';
							if(catalogele.rt_cf_p_individual_catalog3_href) {
								if(catalogele.rt_cf_p_individual_catalog3_href.href) {
									_href = catalogele.rt_cf_p_individual_catalog3_href.href;
								}
							}
							let _size = '';
							if(catalogele.rt_cf_p_individual_catalog3_size) {
								if(catalogele.rt_cf_p_individual_catalog3_size.content) {
									_size = bytesToSize(catalogele.rt_cf_p_individual_catalog3_size.content);
								}
							}
							_catalogarray.push({
								title: catalogele.cf_p_individual_catalog_disp3,
								src: _src,
								href: _href,
								size: _size,
							});
						}
						if(catalogele.cf_p_individual_catalog_disp4) {
							let _src = '';
							if(catalogele.rt_cf_p_individual_catalog4_thumb) {
								if(catalogele.rt_cf_p_individual_catalog4_thumb.src) {
									_src = catalogele.rt_cf_p_individual_catalog4_thumb.src;
								}
							}
							let _href = '';
							if(catalogele.rt_cf_p_individual_catalog4_href) {
								if(catalogele.rt_cf_p_individual_catalog4_href.href) {
									_href = catalogele.rt_cf_p_individual_catalog4_href.href;
								}
							}
							let _size = '';
							if(catalogele.rt_cf_p_individual_catalog4_size) {
								if(catalogele.rt_cf_p_individual_catalog4_size.content) {
									_size = bytesToSize(catalogele.rt_cf_p_individual_catalog4_size.content);
								}
							}
							_catalogarray.push({
								title: catalogele.cf_p_individual_catalog_disp4,
								src: _src,
								href: _href,
								size: _size,
							});
						}
					});
					// console.log(_catalogarray,'_catalogarray');
					const _catalogarrayresult = _catalogarray.filter((item, index, self) => {
						// title だけをリスト化する
						const titleList = self.map(item => item['title']);
						// 重複を削除する
						if (titleList.indexOf(item.title) === index) {
						  return item;
						}
					});
					// console.log(_catalogarrayresult,'_catalogarrayresult');
					let ULHTML = `<ul class="flex spacebetween">`;
					_catalogarrayresult.forEach(catalogarrayelm => {
						ULHTML += `<li>
						<figure><a href="${catalogarrayelm.href}" target="_blank"><img src="${catalogarrayelm.src}" alt=""></a></figure>
						<figcaption>${catalogarrayelm.title}<br><span class="gray"><i class="fa-regular fa-file-pdf"></i>（${catalogarrayelm.size}）</span></figcaption>
						</li>`;
					});
					ULHTML += `</ul>`;
					document.querySelector('.js-products-catalog-block').insertAdjacentHTML('beforeend', HTML);
					document.querySelector('.js-products-catalog-block').insertAdjacentHTML('beforeend', ULHTML);
				});
			});
		}
		// 消込対応
		if(document.querySelectorAll('.js-general-catalogArea').length) {
			if(!(document.querySelector('.js-general-catalogArea').querySelectorAll('li').length)) {
				document.querySelector('.js-general-catalogArea').classList.add('di_none');
			}
		}
	};
	const productliblalynews = () => {
		const blockAreaWrap = document.querySelector('.js-productsLibraly-block');
		const blockArea = document.querySelector('.js-productsLibraly-block > ul');
		const bytesToSize = (bytes) => {
			var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
			if (bytes === 0) {
				return 'n/a';
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			if (i === 0) {
				return bytes + ' ' + sizes[i];
			}
			return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
		}
		const getJSONfiles = () => {
			if(location.pathname.split('/')[3] == 'civilnews') {
				return `/ajax/ilibrary/civilnews.json`;
			} else if(location.pathname.split('/')[3] == 'farmnews') {
				return `/ajax/ilibrary/farmnews.json`;
			}
		};
		const HTML1 = (_type,_title,_href,_size,_year,_month,_day,_type3size) => {
			// let title = `${_title} (${_year}年${_month}月${_day}日)`;
			let title = `${_title}`;
			if(_title.indexOf('(訂正') !== -1) {
				title = `└ ${_title}`;
			}
			if(_type == '2') {
				return `<li><p class="ico_pdf"><a href="${_href}" target="_blank">${title}<span class="ico_pdf_in">(${_size})</span></a></p></li>`;

			} else if(_type == '3') {
				if(_type3size) {
					return `<li><p class="ico_pdf"><a href="${_href}" target="_blank">${title}<span class="ico_pdf_in">(${_type3size})</span></a></p></li>`;
				} else {
					return `<li><p class="ico_external"><a href="${_href}" target="_blank">${title}</a></p></li>`;
				}
			}
		};
		document.querySelectorAll('.js-pdfByte').forEach(function (pdfElement) {
			pdfElement.innerText = bytesToSize(pdfElement.innerText);
		});
		fetch(getJSONfiles()).then(function (data) {
			return data.json();
		}).then(function (data) {
			const groups = new Map();
			data.rt_bn_news_list.forEach((elem,idx) => {
				// console.log(elem,'elem');
				if(!idx == 0) {
					let date1 = new Date(elem.cf_n_date);
					let year = date1.getFullYear();
					let section = date1.getFullYear();
					let month = (date1.getMonth()+1);
					let day = date1.getDate();
					let size = '';
					let typesize = 0;
					if(elem.cf_n_attachment_file_size) {
						size = bytesToSize(elem.cf_n_attachment_file_size);
					}
					if(!groups.has(section)) {
						groups.set(section, [] );
					}
					if(elem.cf_n_url_file_size) {
						typesize = bytesToSize(elem.cf_n_url_file_size);
					}
					groups.get(section).push({
						href: elem.rt_cf_n_href.href,
						title: elem.cf_n_title,
						size: size,
						section: section,
						year: year,
						month: month,
						day: day,
						type: elem.cf_n_type,
						type3size: typesize,
					});
				}
			});
			groups.forEach((elem, index) => {
				let HTML = ''; 
				HTML = `<li>
				<h4 class="ico_plus">${index}年</h4>
				<ul class="ul_news hide">`;
				elem.forEach(item => {
					HTML += HTML1(item.type,item.title,item.href,item.size,item.year,item.month,item.day,item.type3size);
				});
				HTML += `</ul></li>`;
				blockArea.insertAdjacentHTML('beforeend', HTML);
			});
			document.querySelectorAll(".ul_accordion li h4").forEach(function (h4Element) {
				h4Element.addEventListener("click", function () {
					var ulNewsElement = this.parentElement.querySelector(".ul_news");
					if (ulNewsElement.classList.contains('hide')) {
						ulNewsElement.classList.remove('hide');
						this.classList.toggle('ico_plus');
						this.classList.toggle('ico_minus');
					} else {
						ulNewsElement.classList.add('hide');
						this.classList.toggle('ico_minus');
						this.classList.toggle('ico_plus');
					}
				});
			});
		});
	};
	productliblalycatalog();
	if(document.querySelectorAll('.js-productsLibraly-block').length) {
		productliblalynews();
	}
})(window.FUNCTIONS);